import * as React from 'react'

import Page from './Page'
import Container from './Container'
import Loadingbar from './Loaderbar'
import FullSizeSection from './FullSizeSection'
import FullSizePage from './FullSizePage'
import FullSizeGallery from './FullSizeGallery'
import styled from '../../utils/styled'
import StringHelper from '../../utils/StringHelper'
import sizeMe from 'react-sizeme';
import { darken } from 'polished'
import { Themed } from 'react-emotion'

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowLeft, faArrowUp } from '@fortawesome/free-solid-svg-icons'
library.add(faArrowRight, faArrowLeft)

interface ShowLayoutProps {
  title: string,
  subtitle: string,
  category: string,
  size: any,
  logo: string,
  data: any,
  selected: any,
  history: any,
  loading: boolean,
}

const ShowLayout: React.FunctionComponent<IndexGalleryProps> = ({  title, subtitle, loading, category, size, data, selected, history }) => {

 function toTop(event:any) {
    scroll.scrollTo(0, {smooth: true});
  }
  function createMarkup(str: string) {
    return {
      __html: str
    }
  }
  function goto(event:any) {
    const  route = $(event.currentTarget).attr("to")
    //history.push(route);
  }
  function handleScroll(event:any) {
    // console.log("scrolling", scrollTo);
    // let y = $(event.currentTarget).offset().top-($(event.currentTarget).height()/2);
    // scroll
  }
return (
      <Page>
        <Container>
          <Wrapper>
            {loading && <Loadingbar />}

             {selected!=undefined && (
              <div>
                <Buttons>
                {selected.hasOwnProperty('previous') && (<PreviousButton role="button"
                // onClick={goto}
                href={`/${category}/${(selected.previous.url_name)}`}><FontAwesomeIcon icon={faArrowLeft} /><span>{selected.previous.name}</span></PreviousButton>)}
                {selected.hasOwnProperty('next') && (<NextButton role="button"
                // onClick={goto}
                href={`/${category}/${(selected.next.url_name)}`}><span>{selected.next.name}</span><FontAwesomeIcon icon={faArrowRight} /></NextButton)}
                <BackButton role="button"
                // onClick={goto}
                href={`/${category}`}><FontAwesomeIcon icon={faArrowUp} /></BackButton>
                </Buttons>
                <FullSizeSection
                  title={selected.name}
                  subtitle=""
                  backgroundImage={
                    selected.hasOwnProperty('cover') ? selected.cover.url : undefined
                  }
                  className={"project " + selected.theme}
                >
                  {/* {selected.hasOwnProperty('accesskey') && (selected.accesskey)} */}
                  <div dangerouslySetInnerHTML={createMarkup(selected.description)} />
                   {selected.hasOwnProperty('summary') && (<div dangerouslySetInnerHTML={createMarkup(selected.summary)} />)}
                   {selected.hasOwnProperty('url') && (<Link href={selected.url} target="_blank">{selected.url}</Link>)}
                </FullSizeSection>
                {selected.hasOwnProperty("pages") && selected.pages.map((page, index) => (
                  <FullSizePage
                    key ={index}
                    title={page.title}
                    subtitle={page.subtitle}
                    media={page.hasOwnProperty('media') ? page.media : undefined}
                    theme={page.theme}
                  >
                    <div dangerouslySetInnerHTML={createMarkup(page.body)} />
                  </FullSizePage>
                ))}
                {selected.hasOwnProperty('galleryid') && selected.galleryid>0 && (
                  <FullSizeGallery galleryid={selected.galleryid} />
                )}
              </div>
            )}

          </Wrapper>
        </Container>
      </Page>
    )
}

export default ShowLayout;

const Wrapper = styled('div')`
  position: relative;
  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    margin: 0;
    flex: 1 0 340px;
  }

`
const Link = styled('a')`
  margin-top: 20px;
  display: block;

`
const Buttons = styled('div')`
  position:fixed;
  top:0px;

  z-index: 100;
  height: 45px;
  /* background-color: rgba(0,0,0,.4); */
  width: 100%;
  a {
    position:fixed;
    top:10px;
    z-index: 10;
    color: #fff!important;
    text-shadow: 1px 0px rgba(0,0,0,.5);
    background-color: rgba(0,0,0,.4);
    padding: 0px .5em;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex-flow: row;
svg {
      margin: .3em .2em ;
    }
    @media (max-width: 991.98px) {

    max-width: 40%;
    top: 60px;
    span {
      max-width: 90%;
      white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    }

                }
  }

`
const NextButton = styled('a')`
  right: 100px;
  @media (max-width: 991.98px) {
    right: 2px;
                }
`
const PreviousButton = styled('a')`
  left: 20px;
  @media (max-width: 991.98px) {
    left: 2px;
                }
`

const BackButton = styled('a')`
  left: 50%;
  transform: translate(-50, 0%);
  @media (max-width: 991.98px) {
    margin-left: -10px;
                }
`
